import { ApiPath } from 'enums';
import { Get, Post, Put } from 'utils';

export const getTransactions = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Transaction}`, query);
  return res.data;
};

export const getTransactionProductCustomerAccount = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Transaction}/customer-account/${query.customerAccountId}/product`, query);
  return res.data;
};

export const createTransaction = async ({ ...body }) => {
  const res = await Post(`${ApiPath.Transaction}`, body);
  return res.data;
};

export const updateTransaction = async ({ transactionId, ...body }) => {
  const res = await Post(`${ApiPath.Transaction}/update`, { ...body, transactionId });
  return res.data;
};

export const updateTransactionStatus = async ({ transactionId, ...body }) => {
  const res = await Put(`${ApiPath.Transaction}/status`, { ...body, transactionId });
  return res.data;
};
